import { IconUser } from "@/shared/icons";
import { Avatar, type AvatarProps } from "@radix-ui/themes";

type UserAvatarProps = AvatarProps;

export default function UserAvatar({
  fallback = <IconUser />,
  radius = "full",
  ...props
}: UserAvatarProps) {
  return (
    <Avatar
      className="w-10! h-10! bg-[#F2F4F7] overflow-hidden"
      fallback={fallback}
      radius={radius}
      {...props}
    />
  );
}
